import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ToggleSwitch } from './ToggleSwitch';
export function AuthProviderCard({ title, description, enabled, onToggle, children }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "border rounded-lg p-6",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between mb-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "text-xl font-semibold text-gray-900",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-gray-600 mt-1",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ToggleSwitch, {
                        checked: enabled,
                        onChange: onToggle
                    })
                ]
            }),
            enabled && children && /*#__PURE__*/ _jsx("div", {
                className: "space-y-4 mt-4 pt-4 border-t",
                children: children
            })
        ]
    });
}
